import React, { Component } from "react";
import Header from "../../components/header/Header.js";
import TopButton from "../../components/topButton/TopButton.js";
import MySkillsCard from "../../components/mySkillsCard/MySkillsCard.js";
import { Fade } from "react-reveal";
import { mySkills } from "../../portfolio.js";
import "./MySkills.css";
// import MySkillsImg from "./MySkillsImg.js";

class MySkills extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <div className="myskills-main">
        <Header
          theme={theme}
          isDark={this.props.isDark}
          toggleTheme={this.props.toggleTheme}
        />
        <div className="basic-myskills">
          <Fade bottom duration={1000} distance="40px">
            <div className="myskills-heading-div">
              <div className="myskills-heading-img-div">
                {/* <MySkillsImg theme={theme} /> */}
                <img
                  className="myskills-page-poster"
                  src={require("../../assests/pages/myskills.png")}
                  alt=""
                />
              </div>
              <div className="myskills-heading-text-div">
                <h1
                  className="myskills-heading-text"
                  style={{ color: theme.text }}
                >
                  {mySkills?.title}
                </h1>
                <p
                  className="myskills-header-detail-text subTitle"
                  style={{ color: theme.secondaryText }}
                >
                  {mySkills?.description}
                </p>
              </div>
            </div>
          </Fade>
        </div>
        <div className="skills-cards-div-main">
          {mySkills?.data?.map((skill, index) => {
            return <MySkillsCard key={index} skill={skill} theme={theme} />;
          })}
        </div>
        <TopButton theme={this.props.theme} />
      </div>
    );
  }
}

export default MySkills;
